export default "__VITE_ASSET__DOeAbz1b__"